import React, { useEffect } from 'react'
import Waiting from './Waiting.jsx'

const StorageCheck = ({ setStorageCheckComplete, setError }) => {
  useEffect(() => {
    // componentDidMount

    // check local storage space
    // from https://stackoverflow.com/questions/4391575/how-to-find-the-size-of-localstorage
    const localStorageSpaceInKB = () => {
      let allStrings = ''
      for (const key in window.localStorage) {
        if (window.localStorage[key]) {
          allStrings += window.localStorage[key]
        }
      }
      return allStrings ? 3 + (allStrings.length * 16) / (8 * 1024) : 0
    }
    // if we're using more than 4.5MB in localStorage...
    if (localStorageSpaceInKB() < (4.5 * 1024)) {
      setStorageCheckComplete(true)
    } else {
      setError('This browsers local storage is full and is preventing you from logging in. Please clear local storage or contact support for assistance.')
    }
  }, [])

  return (
    <Waiting/>
  )
}
export default StorageCheck
